import { PageHeader, Breadcrumb, Typography, Row, Col } from 'antd'
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';

const HeaderFilter = (props) => {
    const { headerTitle, children, useGoBack } = props
    const navigate = useNavigate();

    return (
        <PageHeader
            className='top_filter'
        >
            <Row justify="space-between" align='middle' style={{ width: '100%', height: '100%' }} >
                <Col style={{ minHeight: 77, display: 'flex', alignItems: 'center' }}>
                    {useGoBack && <Icon icon="material-symbols:arrow-right-alt-rounded" fontSize={40} color="#1a99ca" style={{ fontWeight: 500, cursor: 'pointer' }} rotate={2} onClick={() => navigate(-1)} />}

                    <Breadcrumb separator=" >" style={{ color: "var(--color-blue)", }} >
                        {headerTitle.map((title, i) => (
                            <Breadcrumb.Item key={i} style={{ margin: "0 5px", fontWeight: i === 0 ? 600 : '' }} >
                                <Typography.Text style={{ color: "var(--color-blue)", }} >{title}</Typography.Text>
                            </Breadcrumb.Item>
                        ))}
                    </Breadcrumb>
                </Col>


                {/* <div className='flex_center_ver  ' style={{ gap: 10 }}>

                {useGoBack && <Icon icon="material-symbols:arrow-right-alt-rounded" fontSize={40} color="#1a99ca" style={{ fontWeight: 500, cursor: 'pointer' }} rotate={2} onClick={() => navigate(-1)} />}

                <Breadcrumb separator=" >" style={{ color: "var(--color-blue)", }} >
                    {headerTitle.map((title, i) => (
                        <Breadcrumb.Item key={i} style={{ margin: "0 5px", fontWeight: i === 0 ? 600 : '' }} >
                            <Typography.Text style={{ color: "var(--color-blue)", }} >{title}</Typography.Text>
                        </Breadcrumb.Item>
                    ))}
                </Breadcrumb>
            </div> */}
                <Col style={{ justifyContent: 'flex-end' }} >


                    {children}
                </Col>
            </Row>
        </PageHeader >
    )
}

export default HeaderFilter